import { MglMarker, MglNavigationControl, MglGeolocateControl } from '@advisr/v-mapbox';
import MapMixin from '@/components/core/dtwin/map/mixin';
export default {
  name: 'CoreDtwinMapInstance',
  components: {
    MglMarker,
    MglNavigationControl,
    MglGeolocateControl
  },
  mixins: [MapMixin],
  props: {
    detailsBaseLink: {
      type: String,
      required: false,
      default: 'digitaltwin-mgmt'
    }
  },
  methods: {
    editDtwin(id) {
      this.$router.push({
        path: `/${this.detailsBaseLink}/${id}`
      });
    }
  }
};